import { prop } from 'ramda';
import { branch, renderComponent } from 'recompose';

import Placeholder from 'app/components/Image/Placeholder/Placeholder';

const Image = branch(prop('src'), renderComponent('img'))(Placeholder);

export default Image;
